// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationRunError.yaml
// Generated: 2026-03-17T14:51:32.497Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { IntegrationRunError } from '@/types/integration/IntegrationRunError';

/**
 * IntegrationRunError Service (Read-Only)
 * Query operations for IntegrationRunError via the ABP API.
 */
export const integrationRunErrorService = new ReadOnlyEntityService<IntegrationRunError>(
  '/api/integration/integrationrunerror',
  'IntegrationRunError',
);
